import { Injectable } from '@angular/core';
import { ActivityDto } from '@bo-client/shared/models/activityDto';

@Injectable({
  providedIn: 'root'
})
export class SortService {
  sortByDate(list: any[], sort: string, fieldName: string) {
    if (!list) return list;
    return list.sort((a: ActivityDto, b: ActivityDto) =>
      sort == 'down'
        ? new Date(a[fieldName]) > new Date(b[fieldName])
          ? -1
          : new Date(a[fieldName]) < new Date(b[fieldName])
          ? 1
          : 0
        : new Date(a[fieldName]) < new Date(b[fieldName])
        ? -1
        : new Date(a[fieldName]) > new Date(b[fieldName])
        ? 1
        : 0
    );
  }

  sortListByField(list: any[], fieldName: string, sort: string) {
    if (!list) return list;
    if (sort == 'down') {
      return list.sort((a, b) => (a[fieldName] < b[fieldName] ? -1 : a[fieldName] > b[fieldName] ? 1 : 0));
    } else {
      return list.sort((a, b) => (a[fieldName] > b[fieldName] ? -1 : a[fieldName] < b[fieldName] ? 1 : 0));
    }
  }
}
